import React from 'react';
import { T } from '../traks';
import BigText from '../c/BigText';
import { site_base } from '../Site';

function PrivacyPolicyBT(props) {
	return (
		<div className="container ad_privacy_policy p-4">
			<BigText k="privacy_policy" fallback_lang="da"/>

		</div>
	);
}

function PrivacyPolicy(props) {
	return <PrivacyPolicyBT/>;
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/p/PrivacyPolicy.js